import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { CopyText } from "../CopyText";
import {
  isAutosuggestionVisible,
  isTooManyMatches,
  isNoMatchFoundVisible,
} from "./SuggestionHelpers";

import styles from "./AutoSuggestedDropdown.scss";

const AutoSuggestedDropdown = ({
  getMenuProps,
  open,
  inputValue,
  suggestedItems,
  highlightedIndex,
  getItemProps,
  displaySuggestedItem,
  noResultText,
  resultOverloadedText,
  showSuggestionMinAmount,
  itemToString,
}) => (
  <div className={styles.autoSuggestedDropdown}>
    <ul
      {...getMenuProps()}
      className={cx(styles.autoSuggestedDropdown, styles.menu, {
        [styles.open]: open && inputValue && inputValue.length > 0,
      })}
    >
      {isAutosuggestionVisible(
        open,
        inputValue,
        suggestedItems,
        showSuggestionMinAmount
      ) &&
        suggestedItems.map((item, index) => (
          <li
            key={itemToString(item)}
            className={cx(styles.item, {
              [styles.highlighted]: highlightedIndex === index,
            })}
            {...getItemProps({
              index,
              item,
            })}
          >
            <CopyText>{displaySuggestedItem(item)}</CopyText>
          </li>
        ))}
      {isNoMatchFoundVisible(
        open,
        inputValue,
        suggestedItems,
        showSuggestionMinAmount
      ) && (
        <li className={styles.item}>
          <CopyText>{noResultText}</CopyText>
        </li>
      )}
      {isTooManyMatches(open, inputValue, showSuggestionMinAmount) && (
        <li className={styles.item}>
          <CopyText>{resultOverloadedText}</CopyText>
        </li>
      )}
    </ul>
  </div>
);

AutoSuggestedDropdown.propTypes = {
  itemToString: PropTypes.func.isRequired,
  displaySuggestedItem: PropTypes.func.isRequired,
  getItemProps: PropTypes.func.isRequired,
  getMenuProps: PropTypes.func.isRequired,
  highlightedIndex: PropTypes.number.isRequired,
  inputValue: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  noResultText: PropTypes.string,
  resultOverloadedText: PropTypes.string,
  suggestedItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  showSuggestionMinAmount: PropTypes.number.isRequired,
};
AutoSuggestedDropdown.defaultProps = {
  noResultText: "",
  resultOverloadedText: "",
};

AutoSuggestedDropdown.displayName = "AutoSuggestedDropdown";

export default AutoSuggestedDropdown;
